import { Component, OnInit, Input, inject } from '@angular/core';

import { DatePipe } from '@angular/common';
import { ReceiptPayment, TaskCollection } from 'src/model/taskCollection';
import { ConstructAPI } from 'src/app/API/constructAPI';
import { RestApiService } from 'src/app/API/restapi';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-task-collection-list',
    templateUrl: './task-collection-list.component.html',
    styleUrls: ['./task-collection-list.component.scss'],
    providers: [DatePipe],
    standalone: false
})
export class TaskCollectionListComponent implements OnInit {
  private activeModal = inject(NgbActiveModal);
  private restapi = inject(RestApiService);
  private constructApi = inject(ConstructAPI);
  private datepipe = inject(DatePipe);

  showDate: string;
  loggedInCompanyId: number;

  @Input() selectedDate: Date;
  ngOnInit(): void {
    this.loggedInCompanyId = Number(sessionStorage.getItem("companyId"));
    this.showDate = this.datepipe.transform(this.selectedDate, 'yyyy-MM-dd');

    this.getTaskCollections();
  }

  taskCollectionList: TaskCollection[] = [];
  // receiptPaymentList: ReceiptPayment[] = new Array;

  getTaskCollections() {

    const xhttp = this.restapi.getRequest(this.constructApi.getTaskCollection(this.loggedInCompanyId, this.showDate))
    xhttp.onreadystatechange = () => {
      if (xhttp.readyState == 4 && xhttp.status == 200) {
        // Typical action to be performed when the document is ready:

        const jsonArray = JSON.parse((xhttp.responseText));

        jsonArray.forEach(json => {
          const receiptPaymentList: ReceiptPayment[] = [];
          // get the receipts and payment amount in each task
          json.loans.forEach(collection => {

            const receiptPayment = new ReceiptPayment(collection.receiptNumber, collection.monthlyPayment, collection.balance);

            receiptPaymentList.push(receiptPayment);

          });

          // add each taskCollection into list
          const taskCollection = new TaskCollection(json.id, json.name, json.icNumber, receiptPaymentList);
          this.taskCollectionList.push(taskCollection);

        }
        );

      }
    };

  }

  getTotalMonthlyPayment(taskCollection: TaskCollection) {

    let sumOfMonthly = 0;
    for (let i = 0; i < taskCollection.LoanCollection.length; i++) {
      sumOfMonthly += taskCollection.LoanCollection[i].MonthlyPayment;
    }
    return sumOfMonthly;
  }

  getTotalBalance(taskCollection: TaskCollection) {

    let sumOfBalance = 0;
    for (let i = 0; i < taskCollection.LoanCollection.length; i++) {
      sumOfBalance += taskCollection.LoanCollection[i].Balance;
    }
    return sumOfBalance;
  }

  isNotSchemeA(receiptNumber: string) {

    if (receiptNumber.includes('A'))
      return false;
    else
      return true;

  }

  reset() {
    this.activeModal.close();
  }
}
